import type {} from '@mui/lab/themeAugmentation'
import type {} from '@mui/x-data-grid/themeAugmentation'

import { createTheme } from '@mui/material/styles'
//НЕ УДАЛЯТЬ ИМПОРТ!!!
export const colors = {
  almostWhite: '#FCFCFC',
  black: '#000',
  blue: '#56B7F4',
  darkBg: '#0E1720',
  darkBlue: '#376588',
  darkBorder: '#2F3C4A',
  darkFg: '#222F40',
  darkGrey: '#E5E5E5',
  darkHeader: '#263648',
  darkNav: '#202E3F',
  darkText: '#EFF5FC',
  green: '#30B800',
  hoverGrey: '#F4F4F4',
  lightBg: '#F9F9FA',
  lightBlue: '#CCE9FC',
  lightGrey: '#DFE4E5',
  midGrey: '#E6E6E6',
  orange: '#B88F00',
  pink: '#F51A51',
  red: '#DC1749',
  tooltipLight: '#0F0D041A',
  white: '#fff',
  yellow: '#FFC112',
}

export const getTheme = (isDarkTheme: boolean) => {
  return createTheme({
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            '&.MuiButton-textInfo': {
              '&.Mui-disabled': {
                opacity: 0.4,
              },
              backgroundColor: isDarkTheme ? colors.darkHeader : colors.white,
              boxShadow: isDarkTheme
                ? '0px 2px 10px #1D2937, inset 0px 1px 0px #35455A'
                : '0px 2px 10px rgba(109, 109, 109, 0.25), inset 0px 1px 0px rgba(255, 255, 255, 0.3)',
              color: isDarkTheme ? colors.darkText : colors.black,
            },
            borderRadius: '30px',
            fontSize: '16px',
            fontWeight: 600,
            height: '36px',
            padding: '8px 28px',
            textTransform: 'none',
            whiteSpace: 'nowrap',
          },
          textPrimary: {
            '&.Mui-disabled': {
              color: 'white',
              opacity: 0.6,
            },
            '&:hover': {
              backgroundColor: colors.pink,
            },
            backgroundColor: colors.pink,
            boxShadow:
              '0px 4px 18px rgba(245, 26, 81, 0.35), inset 0px 1px 0px rgba(255, 255, 255, 0.3);',
            color: 'white',
          },
          textSecondary: {
            '&.Mui-disabled': {
              color: isDarkTheme ? colors.black : colors.white,
              opacity: 0.6,
            },
            '&:hover': {
              backgroundColor: isDarkTheme ? colors.white : colors.black,
            },
            backgroundColor: isDarkTheme ? colors.white : colors.black,
            boxShadow:
              '0px 2px 10px rgba(0, 0, 0, 0.25), inset 0px 1px 0px rgba(255, 255, 255, 0.3)',
            color: isDarkTheme ? colors.black : colors.white,
          },
        },
      },
      MuiDataGrid: {
        styleOverrides: {
          cell: {
            borderBottom: isDarkTheme ? '1px solid #2D3E51' : '1px solid #E5E5E5',
          },
          columnHeaders: {
            borderBottom: isDarkTheme ? '1px solid #2D3E51' : '1px solid #E5E5E5',
          },
          footerContainer: {
            borderTop: isDarkTheme ? '1px solid #2D3E51' : '1px solid #E5E5E5',
          },
          root: {
            border: 'none',
          },
        },
      },
      MuiDialog: {
        styleOverrides: {
          paper: {
            background: isDarkTheme ? colors.darkBg : colors.white,
          },
        },
      },
      MuiLoadingButton: {
        styleOverrides: {
          loading: {
            color: 'transparent !important',
          },
          root: {
            '&.MuiButton-textInfo': {
              '& .MuiLoadingButton-loadingIndicator': {
                color: isDarkTheme ? 'white' : 'black',
                opacity: 1,
              },
              '&.Mui-disabled': {
                opacity: 0.8,
              },
              backgroundColor: isDarkTheme ? colors.darkHeader : colors.white,
              boxShadow: isDarkTheme
                ? '0px 2px 10px #1D2937, inset 0px 1px 0px #35455A'
                : '0px 2px 10px rgba(109, 109, 109, 0.25), inset 0px 1px 0px rgba(255, 255, 255, 0.3)',
            },
            '&.MuiButton-textPrimary': {
              '& .MuiLoadingButton-loadingIndicator': {
                color: 'white',
                opacity: 1,
              },
              '&.Mui-disabled': {
                opacity: 0.8,
              },
              backgroundColor: colors.pink,
              boxShadow: isDarkTheme
                ? '0px 2px 10px #1D2937, inset 0px 1px 0px #35455A'
                : '0px 2px 10px rgba(109, 109, 109, 0.25), inset 0px 1px 0px rgba(255, 255, 255, 0.3)',
            },
            '&.MuiButton-textSecondary': {
              '& .MuiLoadingButton-loadingIndicator': {
                color: isDarkTheme ? 'black' : 'white',
                opacity: 1,
              },
              '&.Mui-disabled': {
                opacity: 0.8,
              },
              '&.MuiLoadingButton-loading': {
                color: 'transparent',
              },
              '&:hover': {
                backgroundColor: isDarkTheme ? colors.white : colors.black,
              },
              backgroundColor: isDarkTheme ? colors.white : colors.black,
              boxShadow:
                '0px 2px 10px rgba(0, 0, 0, 0.25), inset 0px 1px 0px rgba(255, 255, 255, 0.3)',
              color: isDarkTheme ? colors.black : colors.white,
            },
            borderRadius: '30px',
            fontSize: '16px',
            fontWeight: 600,
            height: '36px',
            padding: '8px 28px',
            textTransform: 'none',
            whiteSpace: 'nowrap',
          },
        },
      },
      MuiStepper: {
        styleOverrides: {
          root: {
            '& .MuiStep-root': {
              '& .MuiStepLabel-root': {
                '& .MuiStepLabel-iconContainer': {
                  '& .Mui-active': {
                    '& .MuiStepIcon-text': {
                      fill: colors.white,
                    },
                    border: 'none',
                    color: colors.pink,
                  },
                  '& .Mui-completed': {
                    '& .MuiStepIcon-text': {
                      fill: colors.white,
                    },
                    border: 'none',
                    color: colors.green,
                  },
                  '& .MuiStepIcon-root': {
                    '& .MuiStepIcon-text': {
                      fill: isDarkTheme ? colors.white : colors.darkBg,
                    },
                    border: '2px solid #CCCCCC',
                    borderRadius: '50%',
                    color: isDarkTheme ? colors.darkFg : colors.white,
                  },
                },
              },
            },
            backgroundColor: 'transparent',
            minWidth: '460px',
            padding: '0',
          },
        },
      },
      MuiTab: {
        styleOverrides: {
          root: {
            '&.Mui-selected': {
              color: colors.pink,
            },
            color: isDarkTheme ? '#46515E' : '#C4C4C4',
            fontSize: '16px',
            fontWeight: 600,
            lineHeight: '24px',
            textTransform: 'none',
          },
        },
      },
      MuiTabs: {
        styleOverrides: {
          root: {
            '& .MuiTabs-flexContainer': {
              borderBottom: `3px solid ${isDarkTheme ? '#46515E' : '#C4C4C4'}`,
            },
            '& .MuiTabs-indicator': {
              backgroundColor: colors.pink,
              color: colors.pink,
              height: '3px',
            },
            color: colors.pink,
          },
        },
      },
      MuiTooltip: {
        styleOverrides: {
          arrow: {
            '&:before': {
              border: '1px solid ' + isDarkTheme ? colors.darkBorder : colors.tooltipLight,
            },
            color: isDarkTheme ? colors.darkFg : colors.white,
          },
          popperArrow: {
            color: isDarkTheme ? colors.darkFg : colors.white,
            zIndex: 1550,
          },
          tooltip: {
            backgroundColor: isDarkTheme ? colors.darkFg : colors.white,
            border: '1px solid ' + isDarkTheme ? colors.darkNav : colors.tooltipLight,
            color: isDarkTheme ? 'white' : 'black',
            fontSize: '14px',
            fontWeight: 500,
            lineHeight: '20px',
            padding: '12px',
          },
        },
      },
    },
    palette: {
      background: {
        default: isDarkTheme ? colors.darkBg : colors.lightBg,
        paper: isDarkTheme ? colors.darkHeader : colors.white,
      },
      info: { main: colors.darkNav },
      mode: isDarkTheme ? 'dark' : 'light',
      primary: { main: isDarkTheme ? colors.darkText : colors.black },
      secondary: { main: colors.pink },
    },
    typography: {
      fontFamily: [
        'Roboto',
        '-apple-system',
        'BlinkMacSystemFont',
        'Segoe UI',
        'Helvetica Neue',
        'Arial',
        'sans-serif',
        'Apple Color Emoji',
        'Segoe UI Emoji',
        'Segoe UI Symbol',
      ].join(','),
    },
  })
}
